import React from 'react';

import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';

import AddAthlete from './components/AddAthlete';
import AthletePageFinalResult from './components/AthletePageFinalResult';
import Dashboard from './components/Dashboard';
import ExportDataPage from './components/ExportDataPage';
import FloorLayoutPage from './components/FloorLayoutPage';
import FlashCards from './components/FlashCards';
import JoinSession from './components/JoinSession';
import Login from './components/Login';
import NewAthletePage from './components/NewAthletePage';
import Session from './components/Session';
import TestPlayground from './components/TestPlayground';
import ViewAthletes from './components/ViewAthletes';
import {
  AuthProvider,
  useAuth,
} from './contexts/AuthContext';

// Protected route component
function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { currentUser } = useAuth();
  return currentUser ? <>{children}</> : <Navigate to="/login" />;
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/join" element={<JoinSession />} />
          <Route path="/session/:sessionId" element={<Session />} />
          <Route path="/session/:sessionId/athletes" element={<ViewAthletes />} />
          <Route path="/session/:sessionId/athlete-page/:athleteId" element={<NewAthletePage />} />
          <Route path="/session/:sessionId/add-athlete" element={<AddAthlete />} />
          <Route path="/session/:sessionId/athletes-final-result" element={<AthletePageFinalResult />} />
          <Route path="/session/:sessionId/flash-cards" element={<FlashCards />} />
          <Route path="/session/:sessionId/floor-layout" element={<FloorLayoutPage />} />
          <Route path="/session/:sessionId/export" element={<ExportDataPage />} />
          <Route path="/session/:sessionId/test-playground" element={<TestPlayground />} />
          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          <Route path="/" element={<Navigate to="/join" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;